<script setup>
import { useLocalizationStore } from '../../stores/localizationStore';
import Image from '../Common/Image.vue';

const props = defineProps({
    tab: Object,
});

const { $localize } = useLocalizationStore();

</script>

<template>
    <div class="grid grid-cols-2 gap-x-40 items-center">
        <Image
            :light-box="true"
            :image="tab.primaryImage"
        />
        <div class="pt-10">
            <div class="wysiwyg">
                <blockquote v-text="$localize(tab.quote)"></blockquote>
                <cite v-text="$localize(tab.author)"></cite>
            </div>
            <Image
                v-if="tab.authorImage?.src"
                :image="tab.authorImage"
                :cover="true"
                class="rounded-full overflow-hidden size-20 mt-10"
            />
        </div>
    </div>
</template>
